import { ForwardedRef, useEffect, useRef } from 'react';

/**
 * Custom hook to manage ref forwarding
 */
export const useRefForwarding = (ref: ForwardedRef<SVGSVGElement>) => {
	const svgRef = useRef<SVGSVGElement>(null);

	useEffect(() => {
		if (ref) {
			if (typeof ref === 'function') {
				ref(svgRef.current);
			} else {
				ref.current = svgRef.current;
			}
		}
	}, [ref, svgRef.current]);

	return svgRef;
};

